import { utils, writeFile } from "xlsx";

const exportExcel = (
  data: Record<string, number | string | boolean | null>[],
  sheetName: string,
  fileName: string
) => {
  const excelData = utils.json_to_sheet(data);
  const workBook = utils.book_new();
  utils.book_append_sheet(workBook, excelData, sheetName);
  writeFile(workBook, fileName);
};

export { exportExcel };
